export default __webpack_public_path__ + "static/media/ar_2014_image.9628634d.jpg";